module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-img', {
    staticClass: "bg_img",
    attrs: {
      "src": _vm.allDevices.length ?
        require('../../assets/img/bg_error.jpg') :
        require('../../assets/img/bg_OK.jpg')
    }
  }, [(_vm.allDevices.length) ? _c('div', {
    staticClass: "status"
  }, [_c('v-icon', {
    staticClass: "error-list",
    attrs: {
      "color": "red"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-title"
  }, [_c('strong', [_vm._v("Se han detectado fallas")])])], 1) : _c('div', {
    staticClass: "status"
  }, [_c('v-icon', {
    staticClass: "success-list",
    attrs: {
      "color": "green"
    }
  }, [_vm._v("done")]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-title"
  }, [_c('strong', [_vm._v("No se detectan fallas")])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "rounded",
    attrs: {
      "pa-2": ""
    }
  }, [(_vm.allDevices.length) ? _c('v-list', {
    staticClass: "spacious",
    attrs: {
      "id": "errorList"
    }
  }, [_vm._l((_vm.allDevices), function(item, index) {
    return [(index != 0) ? _c('v-divider', {
      key: index
    }) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
      key: item.title,
      staticStyle: {
        "content-visibility": "auto"
      },
      attrs: {
        "avatar": "",
        "append": ""
      },
      on: {
        "click": function($event) {
          return _vm.openDevice(item)
        }
      }
    }, [_c('v-list-tile-avatar', [(item.DeviceType.id == 2) ? _c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('rect', {
      attrs: {
        "y": "10",
        "x": "4",
        "fill": "#f93a2f"
      }
    })]) : _c('v-icon', {
      attrs: {
        "color": "#f93a2f"
      }
    }, [_vm._v("trip_origin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('strong', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.Crops.length ?
      item.Crops[0].name :
      'Sin datos'))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("arrow_forward_ios")])], 1)], 1)]
  })], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('devices-events')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066060d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/DashboardMainScreen.vue
// module id = 756
// module chunks = 2